var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loaderProcessComplete,
          expression: "loaderProcessComplete"
        }
      ],
      staticClass: "container-large hp-10"
    },
    [
      !_vm.isContextNew
        ? _c(
            "step-finalize",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processComplete,
                  expression: "processComplete"
                }
              ],
              staticClass: "wp-6 m-auto"
            },
            [
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Merci de votre confiance et bonne journée sur Sellsy !"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: { label: _vm.$t.__("common.actions.go_sellsy") },
                on: { click: _vm.homeUrl }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isContextNew
        ? _c(
            "step-finalize",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processComplete,
                  expression: "processComplete"
                }
              ],
              staticClass: "wp-6 m-auto"
            },
            [
              !_vm.isContextRenew
                ? _c("h1", { staticClass: "mb-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Votre évolution a bien été prise en compte."
                          )
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isContextRenew
                ? _c("h1", { staticClass: "mb-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Votre renouvellement a bien été pris en compte."
                          )
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Merci de votre confiance et bonne journée sur Sellsy !"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "sellsyaccountmanager.SubscriptionCheckout.continue_to_sellsy"
                  )
                },
                on: { click: _vm.homeUrl }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.processComplete,
              expression: "!processComplete"
            }
          ]
        },
        [
          _c("loader-full-page", { attrs: { display: _vm.loading } }),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                }
              ]
            },
            [
              _c("el-col", { staticClass: "p-5", attrs: { span: 15 } }, [
                _c("div", { staticClass: "grid-content" }, [
                  _c("div", { staticClass: "flex-level flex-bottom" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "round-64 relative dinlineb valign-middle primary-50-bkg"
                      },
                      [
                        _c("i", {
                          staticClass: "fab fa-sellsy absolute-center white",
                          staticStyle: { "font-size": "26px" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("h2", { staticClass: "ml-3 mt-0" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$l10n.__("Abonnement Sellsy")) +
                          "\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-auto left-block" }, [
                    _c("h3", {}, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm.$l10n.__("pour %(company)s", {
                                company: _vm.customerProp.name
                              })
                            )
                          ) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loaderContact,
                            expression: "loaderContact"
                          }
                        ],
                        staticClass: "well p-5 shadow mt-3"
                      },
                      [
                        _c("div", { staticClass: "flex-level" }, [
                          _c("h3", { staticClass: "mt-0 mb-0" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.$l10n.__("informations de contact")
                                  )
                                ) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.editModeContact && _vm.userIsLogged
                            ? _c(
                                "div",
                                { staticClass: "flex-right" },
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.edit"),
                                      type: "tertiary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleContactEditMode()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.editModeContact
                          ? _c(
                              "el-form",
                              {
                                ref: "billingContactForm",
                                staticClass: "mt-4",
                                attrs: {
                                  model: _vm.billingContactTmp,
                                  "label-position": "top",
                                  rules: _vm.samBillingContactRules
                                }
                              },
                              [
                                _c("div", { staticClass: "flex-level" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex pr-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.name"
                                            ),
                                            prop: "contactName",
                                            error: _vm.errors.get("contactName")
                                          }
                                        },
                                        [
                                          _c("text-input", {
                                            attrs: { mode: _vm.mode },
                                            model: {
                                              value:
                                                _vm.billingContactTmp
                                                  .contactName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingContactTmp,
                                                  "contactName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingContactTmp.contactName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex pl-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.first_name"
                                            ),
                                            prop: "contactFirstName",
                                            error: _vm.errors.get(
                                              "contactFirstName"
                                            )
                                          }
                                        },
                                        [
                                          _c("text-input", {
                                            attrs: { mode: _vm.mode },
                                            model: {
                                              value:
                                                _vm.billingContactTmp
                                                  .contactFirstName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingContactTmp,
                                                  "contactFirstName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingContactTmp.contactFirstName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.labels.email_address"
                                      ),
                                      prop: "contactEmail",
                                      error: _vm.errors.get("contactEmail")
                                    }
                                  },
                                  [
                                    _c("text-input", {
                                      attrs: { type: "email", mode: _vm.mode },
                                      model: {
                                        value:
                                          _vm.billingContactTmp.contactEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.billingContactTmp,
                                            "contactEmail",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "billingContactTmp.contactEmail"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__("common.labels.phone"),
                                      prop: "contactPhone",
                                      error: _vm.errors.get("contactPhone")
                                    }
                                  },
                                  [
                                    _c("tel-input", {
                                      attrs: { mode: _vm.mode },
                                      on: {
                                        change: _vm.updateBilligContactPhoneTmp
                                      },
                                      model: {
                                        value: _vm.billingContactPhoneTmp,
                                        callback: function($$v) {
                                          _vm.billingContactPhoneTmp = $$v
                                        },
                                        expression: "billingContactPhoneTmp"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.labels.invoicing_language"
                                      ),
                                      prop: "locale",
                                      error: _vm.errors.get("locale")
                                    }
                                  },
                                  [
                                    _c("select-input", {
                                      staticClass: "m-0",
                                      attrs: {
                                        mode: _vm.mode,
                                        options: _vm.billingLocales,
                                        "label-column": "name",
                                        "id-column": "code",
                                        filterable: true
                                      },
                                      model: {
                                        value: _vm.billingContactTmp.locale,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.billingContactTmp,
                                            "locale",
                                            $$v
                                          )
                                        },
                                        expression: "billingContactTmp.locale"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "aright mt-6 mb-0" },
                                  [
                                    _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__(
                                          "common.actions.cancel"
                                        ),
                                        type: "secondary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleContactEditMode()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("CompassButton", {
                                      staticClass: "ml-3",
                                      attrs: {
                                        label: _vm.$t.__("common.actions.save")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.submitForm(
                                            "billingContactForm",
                                            "saveBillingContact"
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c("div", { staticClass: "fs-3 mt-3" }, [
                              _vm.isContactValid(_vm.billingContact)
                                ? _c("div", [
                                    _c("p", { staticClass: "m-0" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.billingContact.contactName
                                          ) +
                                          "\n                                        " +
                                          _vm._s(
                                            _vm.billingContact.contactFirstName
                                          ) +
                                          "\n                                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0 mt-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.billingContact.contactEmail)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0 mt-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.billingContact.contactPhone)
                                      )
                                    ])
                                  ])
                                : _c("p", { staticClass: "italic red" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Informations manquantes"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ])
                            ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loaderAddress,
                            expression: "loaderAddress"
                          }
                        ],
                        staticClass: "well p-5 shadow mt-4"
                      },
                      [
                        _c("div", { staticClass: "flex-level" }, [
                          _c("h3", { staticClass: "mt-0 mb-0" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.$l10n.__("informations de facturation")
                                  )
                                ) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.editModeAddress && _vm.userIsLogged
                            ? _c(
                                "div",
                                { staticClass: "flex-right" },
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.edit"),
                                      type: "tertiary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleAddressEditMode()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.editModeAddress
                          ? _c(
                              "el-form",
                              {
                                ref: "billingAddressForm",
                                staticClass: "mt-4",
                                attrs: {
                                  model: _vm.billingAddressTmp,
                                  "label-position": "top",
                                  rules: _vm.samBillingAddressAndIntraVatRules
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.labels.street_name"
                                      ),
                                      prop: "line1",
                                      error: _vm.errors.get("line1")
                                    }
                                  },
                                  [
                                    _c("algolia-places", {
                                      attrs: {
                                        "default-value":
                                          _vm.billingAddressTmp.line1,
                                        templates: {
                                          value: function(suggestion) {
                                            return suggestion.name
                                          }
                                        }
                                      },
                                      on: {
                                        "bubble-address": _vm.captureAddress
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.labels.more_address_informations"
                                      ),
                                      prop: "line2",
                                      error: _vm.errors.get("line2")
                                    }
                                  },
                                  [
                                    _c("text-input", {
                                      attrs: { mode: "edit" },
                                      model: {
                                        value: _vm.billingAddressTmp.line2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.billingAddressTmp,
                                            "line2",
                                            $$v
                                          )
                                        },
                                        expression: "billingAddressTmp.line2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex-level" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex pr-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.postal_code"
                                            ),
                                            prop: "postalCode",
                                            error: _vm.errors.get("postalCode")
                                          }
                                        },
                                        [
                                          _c("text-input", {
                                            attrs: { mode: "edit" },
                                            model: {
                                              value:
                                                _vm.billingAddressTmp
                                                  .postalCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingAddressTmp,
                                                  "postalCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingAddressTmp.postalCode"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex-3 pl-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.city"
                                            ),
                                            prop: "city",
                                            error: _vm.errors.get("city")
                                          }
                                        },
                                        [
                                          _c("text-input", {
                                            attrs: { mode: "edit" },
                                            model: {
                                              value: _vm.billingAddressTmp.city,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingAddressTmp,
                                                  "city",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingAddressTmp.city"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex-level" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex pr-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.state"
                                            ),
                                            prop: "state",
                                            error: _vm.errors.get("state")
                                          }
                                        },
                                        [
                                          _c("text-input", {
                                            staticClass: "m-0",
                                            attrs: { mode: "edit" },
                                            model: {
                                              value:
                                                _vm.billingAddressTmp.state,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingAddressTmp,
                                                  "state",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingAddressTmp.state"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex pl-2" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.labels.country"
                                            ),
                                            prop: "country",
                                            error: _vm.errors.get("country")
                                          }
                                        },
                                        [
                                          _c("select-input", {
                                            staticClass: "m-0",
                                            attrs: {
                                              mode: "edit",
                                              options: _vm.countries,
                                              "label-column": "name",
                                              "id-column": "code",
                                              filterable: true
                                            },
                                            model: {
                                              value:
                                                _vm.billingAddressTmp.country,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingAddressTmp,
                                                  "country",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingAddressTmp.country"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.hasCountryIntraVat(
                                  _vm.billingAddressTmp.country
                                )
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-3" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "Entrez un numéro de TVA intracommunautaire ci-dessous pour être facturé en franchise de TVA."
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t.__(
                                                "sellsyaccountmanager.SubscriptionCheckout.VAT_number"
                                              ),
                                              prop: "vatIdentificationNumber",
                                              error: _vm.errors.get(
                                                "vatIdentificationNumber"
                                              )
                                            }
                                          },
                                          [
                                            _c("text-input", {
                                              attrs: { mode: "edit" },
                                              model: {
                                                value:
                                                  _vm.billingAddressTmp
                                                    .vatIdentificationNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billingAddressTmp,
                                                    "vatIdentificationNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billingAddressTmp.vatIdentificationNumber"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "aright mt-6 mb-0" },
                                  [
                                    _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__(
                                          "common.actions.cancel"
                                        ),
                                        type: "secondary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleAddressEditMode()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("CompassButton", {
                                      staticClass: "ml-3",
                                      attrs: {
                                        label: _vm.$t.__("common.actions.save")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.submitForm(
                                            "billingAddressForm",
                                            "saveBillingAddressAndVatIdentificationNumber"
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c("div", { staticClass: "fs-3 mt-3" }, [
                              _vm.isAddressValid(_vm.billingAddress)
                                ? _c("div", [
                                    _c("p", { staticClass: "m-0 mt-1" }, [
                                      _vm._v(_vm._s(_vm.billingAddress.line1))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0 mt-1" }, [
                                      _vm._v(_vm._s(_vm.billingAddress.line2))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0 mt-1" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.billingAddress.postalCode
                                          ) +
                                          "\n                                        " +
                                          _vm._s(_vm.billingAddress.city) +
                                          " - " +
                                          _vm._s(_vm.billingAddress.country) +
                                          "\n                                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.hasCountryIntraVat(
                                      _vm.billingAddress.country
                                    )
                                      ? _c("p", { staticClass: "m-0 mt-3" }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$l10n.__("N° de TVA")
                                              ) +
                                              "\n                                        " +
                                              _vm._s(
                                                _vm.billingSettings
                                                  .vatIdentificationNumber
                                              ) +
                                              "\n                                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _c("p", { staticClass: "italic red" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "Informations manquantes"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ])
                            ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "well p-5 shadow mt-4" }, [
                      _c("h3", { staticClass: "mt-0" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$l10n.__("moyen de paiement")
                              )
                            ) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          !_vm.hasManualPaymentMethod
                            ? _c("payment-methods", {
                                attrs: { corporation: _vm.corporation }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasManualPaymentMethod &&
                          (_vm.isCartContext("new") ||
                            _vm.isCartContext("legacy_renew"))
                            ? _c("p", { staticClass: "fs-3 gray-60" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous. A réception du virement nous procéderons à l’activation de votre compte."
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasManualPaymentMethod &&
                          _vm.isCartContext("renew")
                            ? _c("p", { staticClass: "fs-3 gray-60" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous."
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasManualPaymentMethod &&
                          _vm.isCartContext("upsale")
                            ? _c("p", { staticClass: "fs-3 gray-60" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Merci d’effectuer un virement du montant de la facture vers le compte ci-dessous."
                                      )
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasManualPaymentMethod
                            ? _c(
                                "div",
                                { staticClass: "mt-2" },
                                [
                                  _c("p", { staticClass: "m-0 fs-3 gray-60" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm.$l10n.__("Titulaire du compte")
                                          )
                                        ) +
                                        "\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "m-0 fs-3 semibold" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.$l10n.__(
                                                "SAS SELLSY - AVENUE DU LAZARET 17000 LA ROCHELLE"
                                              )
                                            )
                                          ) +
                                          "\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "line-2-slots",
                                    { staticClass: "fs-3 mt-2" },
                                    [
                                      _c("template", { slot: "left" }, [
                                        _c(
                                          "p",
                                          { staticClass: "m-0 fs-3 gray-60" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.$l10n.__(
                                                      "IBAN (International Bank Account Number)"
                                                    )
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "m-0 fs-3 semibold" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.$l10n.__(
                                                      "FR76 1090 7008 6103 0211 3904 631"
                                                    )
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("template", { slot: "right" }, [
                                        _c(
                                          "p",
                                          { staticClass: "m-0 fs-3 gray-60" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.$l10n.__(
                                                      "BIC (International Code)"
                                                    )
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "m-0 fs-3 semibold",
                                            attrs: { align: "right" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.$l10n.__("CCBPFRPPBDX")
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors.get("card")
                        ? _c("span", { staticClass: "red error semibold" }, [
                            _vm._v(_vm._s(_vm.errors.get("card"))),
                            _c("br")
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 9 } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid-content well p-8 b-0 fixed top-0 hp-10 wp-4 ovy-scroll right-0"
                  },
                  [
                    !_vm.loading
                      ? _c(
                          "div",
                          {
                            staticClass: "subscription-preview-container m-auto"
                          },
                          [
                            _c("subscription-preview", {
                              attrs: {
                                "is-monthly":
                                  _vm.cartProp.pricingPlanId === "MONTHLY",
                                cart: _vm.cartProp,
                                "country-code": _vm.billingAddress.country,
                                "click-enabled": _vm.readyToPay,
                                "has-manual-payment-method":
                                  _vm.hasManualPaymentMethod
                              },
                              on: { clicked: _vm.save }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }